import { Cards, Box, Header, SpaceBetween, Button } from '@cloudscape-design/components';
import { templateRegistry } from '../templates/registry';

interface TemplateGalleryProps {
  onSelectTemplate: (configType: string) => void;
  onCreateFromScratch: () => void;
  onImportJson: () => void;
}

/**
 * Template gallery displaying available configType templates as cards.
 * Requirements: 3.1, 3.2, 3.3, 3.4, 3.7
 */
export function TemplateGallery({
  onSelectTemplate,
  onCreateFromScratch,
  onImportJson,
}: TemplateGalleryProps) {
  const templates = Array.from(templateRegistry.values());

  return (
    <SpaceBetween size="l">
      <Header
        variant="h2"
        description="Choose a template to get started, create from scratch, or import JSON."
        actions={
          <SpaceBetween direction="horizontal" size="xs">
            <Button onClick={onImportJson}>Import JSON</Button>
            <Button onClick={onCreateFromScratch}>Create from scratch</Button>
          </SpaceBetween>
        }
      >
        Create Configuration
      </Header>

      <Cards
        items={templates.filter((t) => t.configType !== 'custom')}
        cardDefinition={{
          header: (item) => (
            <Box fontWeight="bold" fontSize="heading-s">
              {item.displayName}
            </Box>
          ),
          sections: [
            {
              id: 'description',
              content: (item) => <Box variant="p">{item.description}</Box>,
            },
            {
              id: 'fields',
              header: 'Fields',
              content: (item) => (
                <Box variant="small" color="text-body-secondary">
                  {item.payloadSchema.length} configurable fields
                </Box>
              ),
            },
            {
              id: 'action',
              content: (item) => (
                <Button variant="primary" onClick={() => onSelectTemplate(item.configType)}>
                  Use template
                </Button>
              ),
            },
          ],
        }}
        cardsPerRow={[{ cards: 1 }, { minWidth: 400, cards: 2 }, { minWidth: 800, cards: 3 }]}
        empty={
          <Box textAlign="center">No templates available.</Box>
        }
      />
    </SpaceBetween>
  );
}
